import React from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

import { MetricContainer, MetricsRow } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import {
    OrganicTopKeywordsCompare,
    PaidTopKeywordsCompare,
} from "app/pages/website-performance/components/SearchTraffic/WWOTopKeywords";
import DurationService from "app/services/DurationService";

const WWOSearchTrafficCompare = (props) => {
    const { showGAApprovedData, getCtaLink, unlockHook = null, hideFooter = false } = props;
    const { params } = useCurrentStateAndParams();
    const { country, key, isWWW, duration } = params;
    const { forAPI } = DurationService.getDurationData(duration);
    const { from, to, isWindow } = forAPI;
    const queryParams = {
        country,
        from,
        includeSubDomains: isWWW === "*",
        isWindow,
        keys: key,
        to,
        webSource: "Total",
    };
    const [noDataState, setNoDataState] = React.useState({
        topKeywordsOrganic: false,
        topKeywordsPaid: false,
    });
    if (!key) {
        return null;
    }
    const commonProps = { queryParams, noDataState, setNoDataState, getCtaLink, unlockHook };
    return (
        <MetricsRow>
            <MetricContainer
                width={"100%"}
                height={"395px"}
                padding={0}
            >
                {props.organic ? (
                    <OrganicTopKeywordsCompare
                        {...commonProps}
                        routingParams={{
                            ...params,
                            showGAApprovedData,
                        }}
                        hideFooter={hideFooter}
                    />
                ) : (
                    <PaidTopKeywordsCompare
                        {...commonProps}
                        routingParams={{
                            ...params,
                            showGAApprovedData,
                        }}
                        hideFooter={hideFooter}
                    />
                )}
            </MetricContainer>
        </MetricsRow>
    );
};

const mapStateToProps = (props) => {
    const { common } = props;
    const { showGAApprovedData } = common;
    return {
        showGAApprovedData,
    };
};

export default connect(mapStateToProps)(WWOSearchTrafficCompare);
